function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.684 14.74l2.842-2.655a9.283 9.283 0 00-.947-.054C6.895 11.91 3 14.233 3 15.644c0 0 1.25 2.79 4.616 4.266 2.237.982 4.341 1.322 6.55.933L8.683 14.74zm1.895-4.515c2.093 0 3.79-1.617 3.79-3.612 0-1.996-1.697-3.613-3.79-3.613-2.094 0-3.79 1.617-3.79 3.613 0 1.995 1.696 3.612 3.79 3.612z",
  fill: "#1976D2"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.814 17.903l-3.288-3.161 1.327-1.274 1.96 1.879 4.86-4.67L21 11.952l-6.186 5.952z",
  fill: "#1976D2"
});

function SvgUserEo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgUserEo;